import styled from 'styled-components'

const InputStyled = styled.div`
  .ant-input-number {
    width: 75px;
  }
`
export default InputStyled
